import React from 'react';
import { Button, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { ExploreIcon, OffersIcon } from '../../../../../shared/Icons';
import { IMyOffers } from '../../dto/IDashboard';
import { useSelector } from 'react-redux';
import { IAllStates } from '../../../../../store/rootReducer';
import { UserRoles } from '../../../../../enum/UserRoles';
import CardLayout from '../../../../../shared/components/card/CardLayout';
import { MUTED_TEXT_COLOR } from '../../../../../utils/constants';
import { FiFileText } from 'react-icons/fi';
import TooltipOverlay from '../../../../../shared/components/tooltip/Tooltip';

interface Props {
    myOffers: IMyOffers;
}

const ExploreOffersCard = ({ myOffers }: Props) => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const {
        user: { userType },
    } = useSelector((reduxState: IAllStates) => reduxState.auth);

    const navigateAction = (route: string) => {
        [UserRoles.AGENCY, UserRoles.AGENCY_MASTER].includes(userType as UserRoles)
            ? navigate(`/agency/${route}`)
            : navigate(`/influencer/${route}`);
    };

    return (
        <CardLayout>
            <Row className="align-items-center h-100">
                <div className="border-right col-6 h-100 d-flex flex-column justify-content-between">
                    <h6 className="d-flex align-items-center text-muted">
                        <ExploreIcon width="20" height="20" color={MUTED_TEXT_COLOR} classes="mr-2" />
                        <div>{t('influencer.dashboard.explore')}</div>
                    </h6>
                    <div className="d-flex align-items-center justify-content-between mt-1">
                        <div className="pl-0">
                            <h5 className="text-primary mb-0">{myOffers?.availableCampaigns ?? 0}</h5>
                            <span>{t('influencer.dashboard.campaigns')}</span>
                        </div>
                        <Button variant="primary" onClick={() => navigateAction('explore')}>
                            {t('general.button.discover')}
                        </Button>
                    </div>
                </div>
                <div className="col-6 h-100 d-flex flex-column justify-content-between">
                    <h6 className="text-muted d-flex align-items-center">
                        <OffersIcon width="20" height="20" color={MUTED_TEXT_COLOR} classes="mr-2" />
                        <div>{t('influencer.explore.offers')}</div>
                    </h6>
                    <div className="d-flex align-items-center justify-content-between mt-1">
                        <div className="col-6 pl-0">
                            <div className="d-flex align-items-center">
                                <h5 className="text-primary mb-0">{myOffers?.received ?? 0}</h5>
                                {!!myOffers?.receivedAmendments && (
                                    <TooltipOverlay
                                        content={t('brand.campaign.book.contract.modal.annex.received_amendments', {
                                            count: myOffers.receivedAmendments,
                                        })}
                                    >
                                        <span className="d-inline-flex align-items-center ml-2 text-warning">
                                            <FiFileText size={18} />
                                        </span>
                                    </TooltipOverlay>
                                )}
                            </div>
                            <span>{t('brand.campaign.book.offer.filters.received')}</span>
                        </div>
                        <Button onClick={() => navigateAction('offers')} variant="outline-primary">
                            {t('influencer.explore.offers')}
                        </Button>
                    </div>
                </div>
            </Row>
        </CardLayout>
    );
};

export default ExploreOffersCard;
